
export const projectCollaborations = [
  {
    id: "collab-1",
    title: "E-commerce Platform with AI Recommendations",
    description: "We're building a next-gen e-commerce platform with AI-powered product recommendations. Looking for frontend and backend developers, as well as AI/ML specialists to join our team.",
    category: "web",
    skillsNeeded: ["React", "Node.js", "TensorFlow", "UI/UX Design", "AWS"],
    timeline: "2-4 weeks",
    budget: "$5,000 - $10,000",
    teamSize: "4",
    location: "Remote",
    owner: {
      name: "Sarah Johnson",
      avatar: "https://randomuser.me/api/portraits/women/44.jpg"
    },
    created: "2023-10-15"
  },
  {
    id: "collab-2",
    title: "Mobile App for Health Monitoring",
    description: "Seeking mobile developers and health data specialists to collaborate on a health monitoring app that tracks user vitals and provides insights through beautiful visualizations.",
    category: "mobile",
    skillsNeeded: ["React Native", "Swift", "Firebase", "Health Data Analytics", "UI/UX Design"],
    timeline: "1-3 months",
    budget: "$10,000 - $20,000",
    teamSize: "3",
    location: "Hybrid",
    owner: {
      name: "Michael Chen",
      avatar: "https://randomuser.me/api/portraits/men/32.jpg"
    },
    created: "2023-10-18"
  },
  {
    id: "collab-3",
    title: "SaaS Dashboard Redesign",
    description: "Our SaaS platform needs a complete dashboard redesign. Looking for UI/UX designers and frontend developers to improve user experience and implement modern design patterns.",
    category: "design",
    skillsNeeded: ["UI/UX Design", "Figma", "React", "CSS/SCSS", "Data Visualization"],
    timeline: "1-2 weeks",
    budget: "$1,000 - $5,000",
    teamSize: "2",
    location: "Remote",
    owner: {
      name: "Emma Wilson",
      avatar: "https://randomuser.me/api/portraits/women/63.jpg"
    },
    created: "2023-10-20"
  },
  {
    id: "collab-4",
    title: "Content Marketing Campaign for Tech Startup",
    description: "Tech startup looking for content creators, SEO specialists, and social media marketers to collaborate on a comprehensive content marketing campaign to drive user acquisition.",
    category: "marketing",
    skillsNeeded: ["Content Writing", "SEO", "Social Media Marketing", "Analytics", "Graphic Design"],
    timeline: "1-3 months",
    budget: "$5,000 - $10,000",
    teamSize: "4",
    location: "Remote",
    owner: {
      name: "Daniel Rodriguez",
      avatar: "https://randomuser.me/api/portraits/men/45.jpg"
    },
    created: "2023-10-22"
  },
  {
    id: "collab-5",
    title: "Blockchain-based Payment System",
    description: "Building a decentralized payment system on blockchain technology. Seeking blockchain developers, security experts, and UI designers familiar with Web3 concepts.",
    category: "web",
    skillsNeeded: ["Blockchain", "Solidity", "Web3.js", "Smart Contracts", "React", "Security"],
    timeline: "3-6 months",
    budget: "$20,000+",
    teamSize: "5",
    location: "Remote",
    owner: {
      name: "Alexandra Kim",
      avatar: "https://randomuser.me/api/portraits/women/28.jpg"
    },
    created: "2023-10-25"
  },
  {
    id: "collab-6",
    title: "3D Game Asset Creation",
    description: "Indie game studio looking for 3D modelers, texture artists, and animators to collaborate on creating game assets for our upcoming fantasy RPG.",
    category: "design",
    skillsNeeded: ["3D Modeling", "Texturing", "Animation", "Blender", "Unity", "Character Design"],
    timeline: "2-4 weeks",
    budget: "$1,000 - $5,000",
    teamSize: "3",
    location: "Remote",
    owner: {
      name: "James Wilson",
      avatar: "https://randomuser.me/api/portraits/men/23.jpg"
    },
    created: "2023-10-28"
  },
  {
    id: "collab-7",
    title: "AI-Powered Learning Platform",
    description: "Educational startup seeking ML engineers, educational content developers, and full-stack developers to build an adaptive learning platform that personalizes content based on student progress.",
    category: "web",
    skillsNeeded: ["Machine Learning", "Python", "React", "Node.js", "Educational Content", "UX Research"],
    timeline: "3-6 months",
    budget: "$10,000 - $20,000",
    teamSize: "5",
    location: "Hybrid",
    owner: {
      name: "Olivia Park",
      avatar: "https://randomuser.me/api/portraits/women/66.jpg"
    },
    created: "2023-10-30"
  },
  {
    id: "collab-8",
    title: "Podcast Production and Marketing",
    description: "Looking to launch a tech podcast and need a team of audio engineers, content writers, and marketing specialists to produce high-quality episodes and grow our audience.",
    category: "content",
    skillsNeeded: ["Audio Editing", "Content Writing", "Social Media Marketing", "Podcast Production", "SEO"],
    timeline: "1-3 months",
    budget: "$1,000 - $5,000",
    teamSize: "3",
    location: "Remote",
    owner: {
      name: "Tyler Martinez",
      avatar: "https://randomuser.me/api/portraits/men/53.jpg"
    },
    created: "2023-11-02"
  }
];
